<div class="duna-event-instructors-respond-container">
  <mat-card>
    <mat-card-header>
      <mat-card-title>Instruktørinvitation – svar på invitation</mat-card-title>
      @if (deadlineDisplay) {
      <mat-card-subtitle>Svarfrist: {{ deadlineDisplay }}</mat-card-subtitle>
      }
    </mat-card-header>
    <mat-card-content>
      @if (loading) {
      <div class="loading"><mat-spinner diameter="40"></mat-spinner></div>
      } @if (error) {
      <p class="error">{{ error }}</p>
      } @if (!loading && !error) {
      <p class="intro">
        Vælg de dage/events, du ønsker at være instruktør på. Under hver dag kan du se
        hvilke moduler der undervises i, og om du tidligere har erfaring med dem.
      </p>
      <ul class="event-list">
        @for (ev of events; track ev.event_id) {
        <li class="event-card" [class.event-card--selected]="isSelected(ev.event_id)">
          <label class="event-select-row">
            <mat-checkbox
              [checked]="isSelected(ev.event_id)"
              (change)="toggle(ev.event_id)"
            >
              <span class="event-title">{{ eventTitle(ev) }}</span>
            </mat-checkbox>
          </label>
          <div class="event-meta-row">
            <span>{{ eventScheduleLine(ev) }}</span>
            @if (ev.location) {
            <span class="event-location">{{ ev.location }}</span>
            }
          </div>
          @if (ev.modules?.length) {
          <div class="modules-block">
            <p class="modules-heading">Moduler denne dag</p>
            <ul class="module-list">
              @for (mod of ev.modules; track mod.module_id) {
              <li class="module-item">
                <div class="module-head">
                  <span class="module-name">{{ mod.name }}</span>
                  @if ((mod.maintenance_minutes ?? 0) > 0) {
                  <span class="module-minutes">{{
                    formatModuleMinutes(mod.maintenance_minutes ?? 0)
                  }}</span>
                  }
                </div>
                @if (mod.description) {
                <p class="module-desc">{{ mod.description }}</p>
                }
                <div class="competency-tags">
                  @if (mod.prior_instructor) {
                  <span class="tag tag--instructor" title="Du har tidligere været instruktør på dette modul">
                    <mat-icon>school</mat-icon>
                    Undervist før
                  </span>
                  } @if (mod.prior_completed) {
                  <span class="tag tag--completed" title="Du har gennemført dette modul som deltager">
                    <mat-icon>check_circle</mat-icon>
                    Gennemført som deltager
                  </span>
                  } @if (!mod.prior_instructor && !mod.prior_completed) {
                  <span class="tag tag--none">
                    <mat-icon>info_outline</mat-icon>
                    Ingen registreret erfaring
                  </span>
                  }
                </div>
              </li>
              }
            </ul>
          </div>
          } @else {
          <p class="no-modules muted">Ingen moduler knyttet til denne dag.</p>
          }
        </li>
        }
      </ul>
      @if (events.length === 0) {
      <p class="muted">Ingen events i denne invitation.</p>
      } @if (saveMessage) {
      <p
        class="save-message"
        [class.error]="saveHadError"
        role="status"
        aria-live="polite"
      >
        {{ saveMessage }}
      </p>
      }
      <button
        mat-raised-button
        color="primary"
        (click)="save()"
        [disabled]="saving || events.length === 0"
      >
        {{ saving ? "Gemmer…" : "Gem mine svar" }}
      </button>
      }
    </mat-card-content>
  </mat-card>
</div>
